import {UI} from "../../stem-core/ui/UIBase";

interface BorderedLabelOptions {
    borderWidth?: number;
    borderColor?: string;
}

export class BorderedLabel extends UI.Primitive("span")<BorderedLabelOptions> {
    getDefaultOptions() {
        return {
            borderWidth: 1,
        }
    }

    extraNodeAttributes(attr) {
        const {borderWidth, borderColor} = this.options;
        attr.setStyle({
            padding: "1px 8px",
            paddingTop: 3,
            border: `${borderWidth}px solid ${borderColor || ""}`,
        });
    }
}
